import { storiesOf } from '@storybook/vue';
import { withKnobs, text, boolean, number, select } from '@storybook/addon-knobs';
import { EventBus } from '@/main/eventBus';
import { PageMode } from '@/main/utils/pageMode';

const stories = storiesOf('Components/DMS/Form', module);
const g = { v: 'Validace', d: 'Default', m: 'Decila setting' };

stories
	.addDecorator(withKnobs)
	.add('Input - Číslo', () => ({
		template: `
		<dms-form :model="$data" :rules="rules">
			<dms-input-number v-bind="$props" :value.sync="value" />
		</dms-form>
		`,
		data() {
			return {
				value: null,
			};
		},
		props: {
			showLabel: {
				default: boolean('Zobrazit label', true, g.d),
			},
			label: {
				default: text('Label', 'Číslo', g.d),
			},
			placeholder: {
				default: text('Placeholder', 'Napište hodnotu...', g.d),
			},
			isRequired: {
				default: boolean('Povinné pole', true, g.d),
			},
			disabled: {
				default: boolean('Disabled', false, g.d),
			},
			minus: {
				default: boolean('Enable negative numbers', true, g.m),
			},
			precision: {
				default: number('Decimal precision', 0, {}, g.m),
			},
			thousandSeparator: {
				default: text('Thousand separator', undefined, g.m),
			},
			decimalSeparator: {
				default: text('Decimal separator', ',', g.m),
			},
			decimalSeparatorIndiaMarket: {
				default: text('Decimal separator', '.', g.m),
			},
			currency: {
				default: text('Currency', '', g.m),
			},
			currencySymbolPosition: {
				default: select('Currency symbol position', ['prefix', 'suffix'], 'prefix', g.m),
			},
		},
		computed: {
			rules() {
				return {
					value: [
						{
							min: this.min, max: this.max, message: `Hodnota musí být mezi ${this.min} a ${this.max}.`, trigger: 'change', type: 'integer',
						},
						{
							required: this.isRequired, trigger: ['change', 'blur'],
						},
					],
				};
			},
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}));
